module.exports = __webpack_public_path__ + "static/media/cs-logo.10f17b35.png";


//////////////////
// WEBPACK FOOTER
// ./public/cs-logo.png
// module id = 297
// module chunks = 0